import useInAppReviewTrigger from './useInAppReviewTrigger';
import useTrackOpenedDaysCount from './useTrackOpenedDaysCount';
import useTrackOpenedDuration from './useTrackOpenedDuration';
export default function useUsageTrackers() {
    useTrackOpenedDaysCount();
    useTrackOpenedDuration();
    useInAppReviewTrigger();
}
